import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://serviceenergyapi.erp-softgroup.link/api',
    withCredentials: true,
});

// Interceptor to attach token from cookies
axiosInstance.interceptors.request.use((config) => {
    const token = getCookie('token'); // or localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

function getCookie(name: string | undefined | null): string | null {
    if (!name) return null;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const cookiePart = parts.pop();
        if (cookiePart) {
            return cookiePart.split(';').shift() || null;
        }
    }
    return null;
}


export default axiosInstance;
